export { default } from './NewsTeaser';
